export default __webpack_public_path__ + "static/media/bannerCrisBarros.580149c1.svg";